type Principal = {
	name: string;
};

export const sortPrincipals = (principalA: Principal, principalB: Principal): number =>
	principalA.name.localeCompare(principalB.name);
